
<b-modal ref="loadingSpinnerModal"
         centered
         no-close-on-backdrop
         no-close-on-esc
         hide-footer
         header-bg-variant="primary"
         header-text-variant="light">
  <template #modal-header>
    <h5 class="modal-title">{{ message }}</h5>
  </template>
  <b-progress>
    <b-progress-bar :value="100" variant="primary" animated>
    </b-progress-bar>
  </b-progress>
</b-modal>
